module.exports = __webpack_public_path__ + "img/organize-business-cards.243942cd.png";